import { configGetLanguage } from 'common/helper/config/get-language';
import { MortgageCampaignEnum } from 'common/module/mortgage/campaign.enum';
import { MortgageCampaignInterface } from 'common/module/mortgage/campaign.interface';
import { MortgageCampaignCss } from 'common/module/mortgage/campaign-css';
import { AssetLoaderCssServiceInterface } from 'common/service/asset-loader-css/service.interface';
import { MortgageCampaignLoaderServiceInterface } from 'common/service/mortgage-campaign-loader/service.interface';

export class MortgageCampaignLoader implements MortgageCampaignLoaderServiceInterface {
  /**
   * Constructor
   */
  constructor(private assetLoaderCssService: AssetLoaderCssServiceInterface) {}

  /**
   * @inheritDoc
   */
  public load(campaign: MortgageCampaignEnum): Promise<MortgageCampaignInterface> {
    return new Promise((resolve, reject) => {
      // Load CSS & JS in parallel
      Promise.all([
        this.assetLoaderCssService.importBundle(MortgageCampaignCss[campaign][configGetLanguage().current]),
        import(
          /* webpackChunkName: "mortgage-campaign-[request]" */
          'common/module/mortgage/campaign/' + campaign + '/view.factory'
        ),
      ])
        .then((result) => {
          const view: MortgageCampaignInterface = result[1].default();

          resolve(view);
        })
        .catch(() => reject(new Error('Unable to load mortgage campaign "' + campaign + '" JS or CSS file(s).')));
    });
  }
}
